import React from 'react';
import Layout from '@layouts/Layout';
import Results from '@containers/Results';
import { WidgetContext } from '@contexts/Widget';

class Page extends React.Component {

    render() {
        return (
            <Layout title={'Home'}>
                <WidgetContext.Consumer>
                    {(widget) => (
                        <Results {...this.props} widget={widget}/>
                    )}
                </WidgetContext.Consumer>
            </Layout>
        );
    }
}

export default Page;